import i18n from 'i18next';

import settings from '@/config/settings';
import { formatDate } from '@/utils/date';
import { formatNumberByLocale } from '@/utils/localeFormatters';

type TranslateFn = (key: string) => string;

export interface FishSpeedTooltipInput {
    swimSpeed?: {
        swimSpeed: number;
        lastSpeedMeasurement: string;
        daypartTag: string | null;
    };
}

export function calculateFishSpeedToolTip(
    alarm: string,
    cage: FishSpeedTooltipInput,
    t: TranslateFn
) {
    const tooltipContent: {
        key: string;
        value: string;
    }[] = [];

    const swimSpeed = cage?.swimSpeed;
    if (alarm !== '' && swimSpeed && swimSpeed.swimSpeed !== undefined) {
        tooltipContent.push(
            {
                key: t('common.labels.status'),
                value: alarm,
            },
            {
                key: t('common.swimSpeed.speed'),
                value: swimSpeed.swimSpeed
                    ? `${formatNumberByLocale(swimSpeed.swimSpeed, i18n.language, 2, '')} ${t('common.labels.swimspeed')}`
                    : t('common.labels.noDataFound'),
            },
            {
                key: t('common.labels.date'),
                value: formatDate(swimSpeed.lastSpeedMeasurement, 'display'),
            },
            {
                key: t('common.labels.daypart'),
                value: swimSpeed.daypartTag ? t(`daypartTag.${swimSpeed.daypartTag}`) : '---',
            }
        );
    } else {
        tooltipContent.push({
            key: t('common.swimSpeed.speed'),
            value: t('common.labels.noDataFound'),
        });
    }
    return tooltipContent;
}

export const getSpeedStatus = (speed: number | undefined, t: TranslateFn): string => {
    if (speed === undefined) {
        return t('common.labels.noDataFound');
    }
    if (speed < settings.swimspeed.low_speed_threshold) {
        return `${t('common.swimSpeed.slowerThan')} ${settings.swimspeed.low_speed_threshold} ${t('common.labels.swimspeed')}`;
    }
    if (speed > settings.swimspeed.high_speed_threshold) {
        return `${t('common.swimSpeed.fasterThan')} ${settings.swimspeed.high_speed_threshold} ${t('common.labels.swimspeed')}`;
    }
    if (speed > settings.swimspeed.medium_speed_threshold) {
        return `${t('common.swimSpeed.fasterThan')} ${settings.swimspeed.medium_speed_threshold} ${t('common.labels.swimspeed')}`;
    }
    return t('common.swimSpeed.normal');
};
